/* Xiaomi 2026 · Sidebar navigation (Ayush's pattern)
 *
 * Sections:
 *   • Today (KPI summary)
 *   • Journey Boards · one entry per lifecycle template
 *   • Partners (all 284 directory)
 *   • Data Quality
 *   • Admin · Templates + Users + Import
 */
import React from 'react';
import { NavLink } from 'react-router-dom';

const NAV = [
  { to: '/xiaomi', label: 'Today', icon: '✨' },
  { to: '/xiaomi/board/gift_15_step', label: 'Gift journeys', icon: '🎁' },
  { to: '/xiaomi/board/service_redemption_15_step', label: 'Service journeys', icon: '📸' },
  { to: '/xiaomi/board/event_invite_15_step', label: 'Event journeys', icon: '🍽️' },
  { to: '/xiaomi/board/staycation_15_step', label: 'Staycation journeys', icon: '✈️' },
  { to: '/xiaomi/board/zsm_gift_15_step', label: 'ZSM gift', icon: '👔' },
  { to: '/xiaomi/gift-ops', label: 'Gift ops · Kavita', icon: '📦' },
  { to: '/xiaomi/ayush/anniversary-push', label: 'Anniversary push · Ayush', icon: '💕' },
  { to: '/xiaomi/partners', label: 'Partners (284)', icon: '🤝' },
  { to: '/xiaomi/matrix', label: 'Utilization matrix', icon: '🟧' },
  { to: '/xiaomi/dbrs', label: 'DBRs · distributors', icon: '🚚' },
  { to: '/xiaomi/approvals', label: 'Approvals inbox', icon: '✅' },
  { to: '/xiaomi/unwrapped', label: 'Unwrapped · year-in-review', icon: '🎁' },
  { to: '/xiaomi/data-quality', label: 'Data quality', icon: '⚠️' },
];

const ADMIN_NAV = [
  { to: '/xiaomi/admin/users', label: 'Users · ZSM/ZH', icon: '👤' },
  { to: '/xiaomi/admin/templates', label: 'Templates', icon: '💬' },
  { to: '/xiaomi/admin/benefits', label: 'Benefits', icon: '🎁' },
  { to: '/xiaomi/admin/zoho-bridge', label: 'Zoho bridge', icon: '🔌' },
  { to: '/xiaomi/admin/import', label: 'Import master', icon: '📥' },
];

export default function XiaomiSidebar() {
  const linkClass = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm transition ${
      isActive
        ? 'bg-[#15110d] text-[#f3e6cf]'
        : 'text-ink hover:bg-[#faf6ef]'
    }`;

  return (
    <aside
      className="w-64 min-h-screen p-5 border-r border-line bg-panel"
      data-testid="xiaomi-sidebar"
    >
      <div className="mb-6">
        <div
          className="text-2xl font-bold"
          style={{ fontFamily: 'Fraunces, serif', color: '#15110d' }}
        >
          Xiaomi <span style={{ color: '#ff6900' }}>ONE</span>
        </div>
        <div className="text-[11px] text-soft mt-0.5 uppercase tracking-wider">
          Concierge tracker · 2026
        </div>
      </div>
      <nav className="space-y-1">
        {NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            end={n.to === '/xiaomi'}
            className={linkClass}
            data-testid={`xiaomi-nav-${n.to.split('/').pop()}`}
          >
            <span className="text-base">{n.icon}</span>
            <span>{n.label}</span>
          </NavLink>
        ))}
        <div className="text-[10px] uppercase tracking-wider text-soft mt-6 mb-1 px-4">
          Admin
        </div>
        {ADMIN_NAV.map((n) => (
          <NavLink
            key={n.to}
            to={n.to}
            className={linkClass}
            data-testid={`xiaomi-nav-${n.to.split('/').pop()}`}
          >
            <span className="text-base">{n.icon}</span>
            <span>{n.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
}
